<template>
  <div>
    <el-form :model="detailForm" ref="detailForm" :rules="rules">
      <table class="table-d">
        <tr>
          <td>Category2</td>
          <td>
            <el-form-item prop="category2Code" style="margin-bottom:0">
              <el-select v-model="detailForm.category2Code" clearable placeholder="请选择" style="width:100%">
                <el-option :key="index" v-for="(item,index) in categoryList2" :label="item.name" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </td>
          <td>供应商集团名称</td>
          <td>{{detailForm.groupName}}</td>
          <td>Facility编号</td>
          <td>{{detailForm.code}}</td>
        </tr>
        <tr>
          <td>Facility名字</td>
          <td>{{detailForm.name}}</td>
          <td>状态</td>
          <td>
            <el-form-item prop="status" style="margin-bottom:0">
              <ic-select clearable table="TM_QSPI_FACILITY" field="STATUS" v-model="detailForm.status" style="width:100%"></ic-select>
            </el-form-item>
          </td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>备注</td>
          <td colspan="6">
            <el-form-item prop="remark" style="margin-bottom:0">
              <el-input v-model="detailForm.remark" type="textarea" :rows="2" clearable style="width:100%"></el-input>
            </el-form-item>
          </td>
        </tr>
      </table>
    </el-form>
    <el-row type="flex" justify="center">
      <el-button type="primary" size="small" @click="onSave">保存</el-button>
    </el-row>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import QspiConfigApi from "@/api/qspiConfig/index";
export default {
  props: ['formData', 'selLists'],
  components: {
    IcSelect,
  },
  data() {
    return {
      categoryList2: [],
      statusList: [],
      detailForm: {
        category2Code:"",
        groupName:"",
        code:"",
        name:"",
        status:"",
        remark:"",
      },
      rules: {
        category2Code: [
          { required: true, message: "请选择Category2", trigger: 'change' }
        ],
        status: [
          { required: true, message: "请选择状态", trigger: 'change' }
        ],
      },
    }
  },
  watch: {
    formData: {
      handler(newV, oldV) {
        console.log('22222', newV);
        this.detailForm = newV
      },
      immediate: true
    },
    selLists: {
      handler(newV, oldV) {
        console.log('newV111', newV);
        this.categoryList2 = JSON.parse(newV)
      },
      immediate: true
    }
  },
  created() {
  },
  methods: {
    onSave() {
      this.$refs['detailForm'].validate((valid) => {
        if (valid) {
          this.categoryList2.forEach(ele => {
            if (ele.code == this.detailForm.category2Code) {
              this.$set(this.detailForm, 'category2Name', ele.name)
            }
          })
          QspiConfigApi.saveQspiFacility(this.detailForm).then(res => {
            console.log('res', res);
            if (res.code === '200') {
              this.$message.success('保存成功')
              this.$emit('closeDialog')
              this.detailForm = {}
            }
          });
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>